/* istanbul ignore file */

import { MenuItem } from './Menu.tsx';
import { IconArrowBarToLeft } from '@tabler/icons-react';
// import debug from 'debug';

// const log = debug('MenuUsuario');
export const MenuItemsUsuario: MenuItem[] = [
    {
        label: 'ESTADÍSTICAS',
        icon: 'stats-up',
        url: '/estadisticas',
    },
    {
        label: 'CONFIGURACION',
        icon: 'panel',
        legacyUrl: '/settings',
    },
    // {
    //     label: 'PERFIL',
    //     icon: iconPanel,
    //     url: '/perfil',
    // },
    {
        label: 'FACTURACION',
        icon: 'credit-card',
        url: '/facturacion',
    },
    {
        label: 'MANUAL',
        newTab: 'https://luker.supporthero.io/',
        icon: 'help',
    },
    {
        label: 'SALIR',
        icon: <IconArrowBarToLeft />,
        url: '/logout',
    },
];
